import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ClientLayout from "../../component/appLayouts/clientLayout/clientLayout";
import DevisService from "../../services/devis.service";
import "./index.scss";
import { useAuth } from "../../component/authProvider";
import ArrowBack from "../../component/icons/arrowBack";
import EmailModal from "../../component/modalEmail/EmailModal";
import CompaniesService from "../../services/companies.service";
import axios from "axios";
import EditCompanyModal from "../../component/modaleditCompany";
import { ToastContainer } from "react-toastify";
const DevisDetailPage = (company, onUpdate) => {
  const { id } = useParams();
  const [devis, setDevis] = useState(null);
  const [clientId, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [facture, setFacture] = useState(null); // State to hold the uploaded file
  const [paiement, setPaiement] = useState(""); // State for paiement status
  const [livraison, setLivraison] = useState(""); // State for livraison status
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState("");
  const [factures, setFactures] = useState([]);
  const { currentUser } = useAuth();
  console.log("Current User:", currentUser);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [localFactures, setLocalFactures] = useState(company.factures || []);

  const [isLoading, setIsLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [editingCompany, setEditingCompany] = useState(null);
  const [paiementStatus, setPaiementStatus] = useState({});

  const handleSendEmail = async ({ to, subject, message }) => {
    try {
      const response = await fetch(
        "https://api.gestiondevis.msit-demo.fr/users/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ to, subject, message }),
        }
      );

      const result = await response.json();
      if (result.success) {
        alert("Email envoyé avec succès !");
      } else {
        alert("Échec de l'envoi de l'email.");
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi de l'email :", error);
      alert("Erreur lors de l'envoi.");
    }
  };
  const fetchDevisDetails = async () => {
    try {
      setLoading(true);
      setError(null);

      const devisData = await DevisService.getDevisById(id);
      console.log("📦 Donnée devis récupérée :", devisData);

      if (!devisData) {
        throw new Error("Devis not found");
      }

      setDevis(devisData);
      setUser(devisData.clientId); // 👈 ici on récupère les infos utilisateur directement
      // Set the initial values for paiement and livraison
      setPaiement(devisData.paiement || "");
      setLivraison(devisData.livraison || "");
    } catch (err) {
      console.error("Error fetching devis details:", err);
      setError(err.message || "Failed to load devis details");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChangeF = (e) => {
    setFactures(Array.from(e.target.files));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFacture(file);
    }
  };

  const handleSubmit = async () => {
    try {
      const updatedDevis = {
        paiement: paiement,
        livraison: livraison,
      };

      // Send the update request
      await DevisService.updateDevis(id, updatedDevis);

      // Refetch the data to ensure state is updated
      await fetchDevisDetails(); // This will refresh the status values

      alert("Paiement et Livraison mis à jour avec succès !");

      if (facture) {
        const formData = new FormData();
        formData.append("facture", facture);

        await DevisService.uploadFacture(id, formData);
        alert("Facture téléchargée avec succès !");
      }
    } catch (err) {
      console.error("Erreur lors de la mise à jour du devis :", err);
      alert("Erreur lors de la mise à jour du devis");
    }
  };

  const handleSubmitF = async (e) => {
    e.preventDefault();

    if (!companyName || !factures || factures.length === 0) {
      alert("Veuillez fournir un nom d'entreprise et au moins une facture.");
      return;
    }

    // Extract the actual client ID (handle both string and object cases)
    let actualClientId;
    if (typeof devis.clientId === "object") {
      actualClientId =
        devis.clientId._id || devis.clientId.id || devis.clientId;
    } else {
      actualClientId = devis.clientId;
    }

    // Validate we have a proper client ID
    if (!actualClientId || typeof actualClientId !== "string") {
      alert("Invalid client ID format");
      return;
    }

    const formData = new FormData();
    formData.append("companyName", companyName);
    formData.append("clientId", actualClientId); // Use the extracted string ID

    factures.forEach((file) => {
      formData.append("facture", file);
    });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/companies/create`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert("Entreprise et factures ajoutées avec succès !");
      console.log(response.data);
      setCompanyName("");
      setFactures([]);

      // Refresh the companies list
      const data = await CompaniesService.getCompaniesByClientId(
        actualClientId
      );
      setCompanies(data);
    } catch (error) {
      console.error("Erreur lors de la création :", error);
      alert("Erreur lors de la création de l'entreprise");
    }
  };
  const handleFileUpload = async () => {
    const file = facture;
    if (!file) {
      alert("Veuillez sélectionner un fichier !");
      return;
    }

    const formData = new FormData();
    formData.append("facture", file);
    console.log("FormData:", formData.get("facture"));

    await DevisService.uploadFacture(id, formData);
    alert("Facture téléchargée avec succès !");
  };

  const handleFactureChange = async (companyId, updatedFactures) => {
    console.log("🚀 ~ handleFactureChange ~ updatedFactures:", updatedFactures);
    if (!companyId) {
      console.error("ID de l'entreprise manquant");
      return;
    }

    setIsLoading(true);
    try {
      const updatedCompany = await CompaniesService.updateFacturesStatus(
        companyId,
        updatedFactures
      );
    } catch (error) {
      console.error("Erreur lors de la mise à jour des statuts", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateCompany = (updatedCompany) => {
    console.log("Updated company:", updatedCompany);
    setCompanies(
      companies.map((c) => (c._id === updatedCompany._id ? updatedCompany : c))
    );
  };
  const fetchCompanies = async () => {
    try {
      // Ensure we're passing the actual ID value
      const data = await CompaniesService.getCompaniesByClientId(
        devis.clientId._id || devis.clientId
      );
      setCompanies(data);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };
  const handleDeleteFacture = async (company, fileName) => {
    console.log("Deleting file:", id);
    console.log(company);
    try {
      await CompaniesService.deleteFacture(company?._id, fileName);
      fetchCompanies();
      alert("Facture supprimée avec succès !");
    } catch (error) {
      console.error("Error deleting facture:", error);
      setError("Erreur lors de la suppression de la facture");
    }
  };

  const handlePaiementChange = async (companyId, filename, newStatus) => {
    try {
      await CompaniesService.updateFacturePaiement(
        companyId,
        filename,
        newStatus
      );

      // Optional: update local state so it reflects instantly
      setPaiementStatus((prev) => ({
        ...prev,
        [`${companyId}-${filename}`]: newStatus,
      }));

      fetchCompanies(); // Refresh companies if needed
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
    }
  };
  useEffect(() => {
    if (id) {
      fetchDevisDetails();
    }
  }, [id]);

  useEffect(() => {
    if (devis?.clientId) {
      // Make sure devis exists and has clientId
      const fetchCompanies = async () => {
        try {
          // Ensure we're passing the actual ID value
          const data = await CompaniesService.getCompaniesByClientId(
            devis.clientId._id || devis.clientId
          );
          setCompanies(data);
        } catch (error) {
          console.error("Error fetching companies:", error);
        }
      };

      fetchCompanies();
    }
  }, [devis?.clientId]); // Add devis.clientId as dependency

  if (loading) {
    return (
      <ClientLayout>
        <div className="devis-details">Loading...</div>
      </ClientLayout>
    );
  }

  if (error) {
    return (
      <ClientLayout>
        <div className="devis-details error">{error}</div>
      </ClientLayout>
    );
  }

  if (!devis) {
    return (
      <ClientLayout>
        <div className="devis-details">No devis found</div>
      </ClientLayout>
    );
  }

  return (
    <ClientLayout>
      <div className="d-lg-flex justify-content-between my-4">
        <h5 className="text-black">
          <Link
            className="text-black text-capitalize"
            onClick={() => navigate(-1)}
          >
            <ArrowBack />
            Détails du devis
          </Link>
        </h5>
      </div>

      <div className="devis-details">
        {/* <h2>Détails du devis</h2> */}

        <div className="section">
          <h4>Informations du client</h4>
          <p>
            <strong>Nom :</strong> {devis?.clientName}
          </p>
          <p>
            <strong>Email :</strong> {devis?.clientEmail}
          </p>
          <p>
            <strong>Téléphone :</strong> {devis?.clientPhone}
          </p>

          {["gestionnaire", "admin"].includes(currentUser?.role) && (
            <div style={{ marginTop: "1rem" }}>
              <div className="row" style={{ marginBottom: "1rem" }}>
                <div className="col-12 col-sm-6 col-md-5">
                  <label htmlFor="pourcentage">
                    <strong>Pourcentage :</strong>
                  </label>
                  <input
                    type="number"
                    id="pourcentage"
                    value={devis.pourcentage || ""}
                    onChange={(e) =>
                      setDevis((prev) => ({
                        ...prev,
                        pourcentage: e.target.value,
                      }))
                    }
                    className="form-control"
                    placeholder="Pourcentage de commission"
                  />
                </div>
              </div>

              {/* Aligning Nom de la personne pour la cooptation and Coptation on the same line */}
              <div className="row" style={{ marginBottom: "1rem" }}>
                <div className="col-12 col-sm-6 col-md-5">
                  <label htmlFor="cooptationPerson">
                    <strong>Nom de la personne pour la cooptation :</strong>
                  </label>
                  <input
                    type=""
                    id="cooptationPerson"
                    value={devis.cooptationPerson || ""}
                    onChange={(e) =>
                      setDevis((prev) => ({
                        ...prev,
                        cooptationPerson: e.target.value,
                      }))
                    }
                    className="form-control"
                    placeholder="Nom de la personne pour la cooptation"
                  />
                </div>

                <div className="col-12 col-sm-6 col-md-5">
                  <label htmlFor="cooptation">
                    <strong>Cooptation :</strong>
                  </label>
                  <input
                    type="number"
                    id="cooptation"
                    value={devis.cooptation || ""}
                    onChange={(e) =>
                      setDevis((prev) => ({
                        ...prev,
                        cooptation: e.target.value,
                      }))
                    }
                    className="form-control"
                    placeholder="Pourcentage de cooptation"
                  />
                </div>
              </div>

              <button
                onClick={async () => {
                  try {
                    await DevisService.updateDevis(devis._id, {
                      pourcentage: devis.pourcentage,
                      cooptation: devis.cooptation,
                      cooptationPerson: devis.cooptationPerson,
                    });
                    alert("Informations enregistrées !");
                  } catch (err) {
                    alert("Erreur lors de l'enregistrement");
                    console.error(err);
                  }
                }}
                className="btn btn-primary"
              >
                Enregistrer
              </button>
            </div>
          )}
        </div>

        <div className="section">
          <h4>Informations du devis</h4>
          {devis.servicesDemandes?.length > 0 && (
            <p>
              <strong>Services demandés :</strong>{" "}
              {devis.servicesDemandes.join(", ")}
            </p>
          )}
          {devis.budgetEstime && (
            <p>
              <strong>Budget estimé :</strong> {devis.budgetEstime}{" "}
              {devis.currency}
            </p>
          )}
          {devis.company && (
            <p>
              <strong>Entreprise :</strong> {devis.company}
            </p>
          )}
          {devis.description && (
            <p>
              <strong>Description :</strong> {devis.description}
            </p>
          )}
          {devis.statut && (
            <p>
              <strong>Statut :</strong>
              <span className="devis-status">{devis.statut}</span>
            </p>
          )}
          {devis.dateSoumission && (
            <p>
              <strong>Date de création de projet</strong>{" "}
              {new Date(devis.dateSoumission).toLocaleDateString()}
            </p>
          )}
          {devis.activitySector && (
            <p>
              <strong>Secteur d'activité :</strong> {devis.activitySector}
            </p>
          )}
          {devis.pieceJointe && (
            <p>
              <strong>Pièce jointe :</strong>
              <a
                href={`${process.env.REACT_APP_API_URL}/devis/image/${devis._id}/pieceJointe`}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                Télécharger
              </a>
            </p>
          )}
        </div>
        {currentUser && currentUser.role !== "client" && (
          <div className="send-email-btn-container">
            <a
              href={`https://mail.google.com/mail/?view=cm&to=${devis?.clientEmail}`}
              target="_blank"
              rel="noreferrer"
              className="send-email-btn"
            >
              Envoyer Email
            </a>
          </div>
        )}

        <br />

      

        {["gestionnaire", "admin"].includes(currentUser?.role) && (
          <div className="section">
            <h4>Ajouter un fournisseur </h4>
            <form onSubmit={handleSubmitF}>
              <div className="form-group">
                <label htmlFor="companyName">Nom du fournisseur</label>
                <input
                  type="text"
                  id="companyName"
                  className="form-control"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  required
                />
              </div>

              {/* Remove the clientId input field entirely */}

              <div className="form-group" style={{ marginTop: "1rem" }}>
                <label htmlFor="factures">Ajouter des factures</label>
                <input
                  type="file"
                  id="factures"
                  multiple
                  className="form-control"
                  onChange={handleFileChangeF}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary mt-3"
                disabled={!companyName || factures.length === 0}
              >
                Créer Fournisseur
              </button>
            </form>
            {editingCompany && (
              <EditCompanyModal
                company={editingCompany}
                onClose={() => setEditingCompany(null)}
                onUpdate={(updatedCompany) => {
                  setCompanies(
                    companies.map((c) =>
                      c._id === updatedCompany._id ? updatedCompany : c
                    )
                  );
                }}
              />
            )}
            <br />
            <div>
              <h2>Liste des fournisseurs</h2>
              {companies.map((company) => (
                <div key={company._id} className="company-card">
                  <div className="company-header">
                    <h4>{company.companyName}</h4>
                    <div className="factures-list">
                      <h5>Factures existantes:</h5>
                      {!company.factures || company.factures.length === 0 ? (
                        <p>Aucune facture disponible</p>
                      ) : (
                        <ul>
                          {company.factures.map((file, index) => (
                            <li key={index}>
                              <div className="file-info mb-2">
                                <a
                                  href={`${process.env.REACT_APP_API_URL}/uploads/factures/${file.path}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "#3cbbbc",
                                    textDecoration: "underline",
                                  }}
                                >
                                  {file.path}
                                </a>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm ms-2"
                                  onClick={() =>
                                    handleDeleteFacture(company, file.path)
                                  }
                                  disabled={isLoading}
                                >
                                  Supprimer
                                </button>
                              </div>

                              <div className="d-flex flex-wrap mb-3">
                                <div className="me-3">
                                  <label className="form-label">
                                    Paiement:
                                  </label>
                                  <select
                                    className="form-select"
                                    value={file.paiement}
                                    onChange={(e) => {
                                      console.log("company", company);

                                      const updatedFactures = [
                                        ...company.factures,
                                      ];
                                      updatedFactures[index].paiement =
                                        e.target.value;
                                      handleFactureChange(
                                        company._id,
                                        updatedFactures
                                      );
                                    }}
                                  >
                                    <option value="non payé">non payé</option>
                                    <option value="payé">payé</option>
                                  </select>
                                </div>

                                <div>
                                  <label className="form-label">
                                    Livraison:
                                  </label>
                                  <select
                                    className="form-select"
                                    value={file.livraison}
                                    onChange={(e) => {
                                      const updatedFactures = [
                                        ...company.factures,
                                      ];
                                      updatedFactures[index].livraison =
                                        e.target.value;
                                      handleFactureChange(
                                        company._id,
                                        updatedFactures
                                      );
                                    }}
                                  >
                                    <option value="non livré">non livré</option>
                                    <option value="livré">livré</option>
                                  </select>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    <button
                      onClick={() => setEditingCompany(company)}
                      className="btn btn-sm btn-primary"
                    >
                      Modifier
                    </button>
                  </div>
                </div>
              ))}

              {editingCompany && (
                <EditCompanyModal
                  company={editingCompany}
                  onClose={() => setEditingCompany(null)}
                  onUpdate={(updatedCompany) => {
                    setCompanies(
                      companies.map((c) =>
                        c._id === updatedCompany._id ? updatedCompany : c
                      )
                    );
                  }}
                />
              )}
            </div>
          </div>
        )}
        {/* Paiement Section 
        {["gestionnaire", "admin"].includes(currentUser?.role) && (
          <div className="section">
            <div className="section">
              <h4>Paiement</h4>
              <div style={{ marginBottom: "1rem" }}>
                <label htmlFor="paiement">
                  <strong>Status de paiement :</strong>
                </label>
                <select
                  id="paiement"
                  value={paiement}
                  onChange={(e) => setPaiement(e.target.value)}
                  className="form-control"
                >
                  <option value="payé">Payé</option>
                  <option value="non payé">Non payé</option>
                  <option value="partiellement payé">Partiellement payé</option>
                </select>
              </div>
            </div>
            <div className="section">
              <h4>Livraison</h4>
              <div style={{ marginBottom: "1rem" }}>
                <label htmlFor="livraison">
                  <strong>Status de livraison :</strong>
                </label>
                <select
                  id="livraison"
                  value={livraison}
                  onChange={(e) => setLivraison(e.target.value)}
                  className="form-control"
                >
                  <option value="livré">Livré</option>
                  <option value="non livré">Non livré</option>
                  <option value="partiellement livré">
                    Partiellement livré
                  </option>
                </select>
              </div>
            </div>{" "}
            <button onClick={handleSubmit} className="btn btn-primary">
              Enregistrer les status
            </button>
          </div>
        )}*/}

        {/* Submit Button
        {["gestionnaire", "admin"].includes(currentUser?.role) && (
          <div className="section">
            <button onClick={handleSubmit} className="btn btn-primary">
              Enregistrer les modifications
            </button>
          </div>
        )} */}

        <EmailModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          clientEmail={clientId?.email}
          onSend={handleSendEmail}
        />
      </div>
    </ClientLayout>
  );
};

export default DevisDetailPage;
